// extracted by mini-css-extract-plugin
export default {"editFormButtonWrapper":"EditFormButtonRenderer_editFormButtonWrapper__ajbiS","editIcon":"EditFormButtonRenderer_editIcon__L7hBw"};